// ABOUTME: Route for /dashboard/recent — renders the recent queries page
import { RecentQueriesPage } from "@/components/dashboard/RecentQueriesPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/recent")({
  component: RecentQueriesPage,
});
